import { useEffect, useState } from "react";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Container, Row, Col, Spinner } from "react-bootstrap";

import Sidebar from "../../comman_page/Sidebar";
import { Footer } from "../../../../../public/containers/footer/Footer";
import { InputField } from "../../../../../sharedComponents/InputField";
import { SharedButton } from "../../../../../sharedComponents/Button";
import { SharedSelect } from "../../../../../sharedComponents/SharedSelect";
import Swal from "sweetalert2";
import { add_discount_codeAPI, discountCodeDraftAPI, studio_Options_listAPI } from "../../../../../Studio-Services/Studio_Services";
import logo from "../../../../../Images/logo_white_web.png";
import { errorAlert } from "../../../../../Static_Services/Alertmsg";
import { useNavigate } from "react-router-dom";
import { AddPassMultiSelect } from "../add_new_pass_type/AddPassMultiSelect";
import { formatString } from "../../../../../sharedComponents/Helper";


const options = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" }
];


export const DiscountCode = () => {
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [amountType, setAmountType] = useState('percent');
    const [data, setData] = useState({
        "code_name": "", "amount": "", "start_date": "", "end_date": "", "single_use": "",
        "passes": false, "products": false, "workshops": false, "services": false
    });
    const [e_data, setE_Data] = useState({
        "code_name": "", "amount": "", "start_date": "", "end_date": "", "single_use": "",
        "passes": false, "products": false, "workshops": false, "services": false
    })

    const [clientOPC, setClientOPC] = useState([]);
    const [selectedClient, setSelectedClient] = useState([]);
    const [clientClear, setClientClear] = useState(0);


    const [passOPC, setPassOPC] = useState([]);
    const [selectedPass, setSelectedPass] = useState([]);
    const [passClear, setPassClear] = useState(0);

    const [productOPC, setProductOPC] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState([]);
    const [productClear, setProductClear] = useState(0);

    const [serviceOPC, setServiceOPC] = useState([]);
    const [selectedService, setSelectedService] = useState([]);
    const [serviceClear, setServiceClear] = useState(0);

    const [workshopOPC, setWorkshopOPC] = useState([]);
    const [selectedWorkshop, setSelectedWorkshop] = useState([]);
    const [workshopClear, setWorkshopClear] = useState(0);

    const checkHandler = (e) => {
        const { name, checked } = e.target;
        setData((pre) => ({ ...pre, [name]: checked }));
    }
    const changeHandler = (e) => {
        const { name, value } = e.target;
        setData((pre) => ({ ...pre, [name]: value }));
        setE_Data((pre) => ({ ...pre, [name]: "" }));
    }

    // my_client_list


    const fetch_pass_list = async () => {
        setLoader(true);
        try {
            const resp = await studio_Options_listAPI();
            if (resp) {
                // Set Pass Options 
                const {
                    pass_data = [],
                    client_data = [],
                    product_data = [],
                    service_data = [],
                    workshop_data = []
                } = resp

                let clientFilter = [];
                (client_data || []).map((e) => {
                    clientFilter.push({ id: e.id, label: (e.first_name + " " + e.last_name) });
                });

                let passFilter = [];
                (pass_data || []).map((e) => {
                    passFilter.push({ id: e.pass_id, label: (e?.pass_name) })
                });

                let productFilter = [];
                (product_data || []).map((e) => {
                    productFilter.push({ id: e.id, label: (e?.product_name) })
                });

                let serviceFilter = [];
                (service_data || []).map((e) => {
                    serviceFilter.push({ id: e.id, label: (e?.service_name) })
                });

                let workshopFilter = [];
                (workshop_data || []).map((e) => {
                    workshopFilter.push({ id: e.workshop_id, label: (e?.workshop_name) })
                });

                setClientOPC(clientFilter);
                setPassOPC(passFilter);
                setProductOPC(productFilter);
                setServiceOPC(serviceFilter);
                setWorkshopOPC(workshopFilter);
            }

        } catch (error) {
            console.log("@Get_List Error", error);
        } finally {
            setLoader(false);
        }

    };

    useEffect(() => {
        fetch_pass_list();
    }, []);


    const createHandler = async () => {
        let isValid = true;
        const code_name = data?.code_name || '';
        const amount = data?.amount || '';
        const start_date = data?.start_date || '';
        const end_date = data?.end_date || '';
        const single_use = data?.single_use || '';

        let isAllUsers = 'No';
        let selectedClientId = selectedClient.filter(item => item?.id).map(item => item.id);
        let selectedPassId = selectedPass.filter(item => item?.id).map(item => item.id);

        let selectedProductId = selectedProduct.filter(item => item?.id).map(item => item.id);
        let selectedServiceId = selectedService.filter(item => item?.id).map(item => item.id);
        let selectedWorkshopId = selectedWorkshop.filter(item => item?.id).map(item => item.id);

        if (selectedClient?.length <= 0) {
            errorAlert("Please select at least one client."); isValid = false;
        }

        if (!code_name) { setE_Data((pre) => ({ ...pre, code_name: "Code name is required" })); isValid = false; }
        if (!amount) { setE_Data((pre) => ({ ...pre, amount: "Percent is required" })); isValid = false; }
        if (!start_date) { setE_Data((pre) => ({ ...pre, start_date: "Start Date is required" })); isValid = false; }
        if (!end_date) { setE_Data((pre) => ({ ...pre, end_date: "End Date is required" })); isValid = false; }
        if (!single_use) { setE_Data((pre) => ({ ...pre, single_use: "Single Use is required" })); isValid = false; }

        if (!isValid) return;

        Swal.fire({
            title: "Are you sure?",
            text: "After publishing, you will only be able to edit the end date. Other fields cannot be modified.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, publish it!"
        }).then(async (result) => {
            if (result.isConfirmed) {

                if (clientOPC?.length === selectedClient?.length) {
                    isAllUsers = "Yes";
                    selectedClientId = []
                }
                const formatCodeName = formatString(code_name);
                const formatAmountType = formatString(amountType);
                const payload = {
                    "code_name": formatCodeName,
                    "amount_type": formatAmountType,
                    "amount": amount,
                    "start_date": start_date,
                    "end_date": end_date,
                    "is_single_use": single_use,
                    "isAllUsers": isAllUsers,
                    "userListId": selectedClientId,
                    "passListId": selectedPassId,
                    "productListId": selectedProductId,
                    "serviceListId": selectedServiceId,
                    "workshopListId": selectedWorkshopId,
                }
                setLoader(true);
                try {
                    const resp = await add_discount_codeAPI(payload);
                    if (resp) {
                        setLoader(false);
                        Swal.fire({
                            html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" alt='' />
                                <h4 class="title text-capitalize text-center mt-4 textWhite">
                                Success
                            </h4>
                            <p class="text-center my-4 textcolor">
                            <small class="textWhite">
                            Discount code has been published successfully. </small></p>
                            `,
                            showClass: {
                                popup: 'custom-dialog-container',
                            },
                            customClass: {
                                confirmButton: 'custom-button custom-button-size modalbtn',
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                setLoader(false);
                                navigate("/discount-code-list");
                            }
                        });
                    }
                } catch (error) {
                    console.log("@Error ", error);
                } finally {
                    setLoader(false);
                }


            }
        });
    }

    const saveHandler = async () => {
        let isValid = true;
        const code_name = data?.code_name || '';
        const amount = data?.amount || '';
        const start_date = data?.start_date || '';
        const end_date = data?.end_date || '';
        const single_use = data?.single_use || '';

        let isAllUsers = 'No';
        let selectedClientId = selectedClient.filter(item => item?.id).map(item => item.id);
        let selectedPassId = selectedPass.filter(item => item?.id).map(item => item.id);

        let selectedProductId = selectedProduct.filter(item => item?.id).map(item => item.id);
        let selectedServiceId = selectedService.filter(item => item?.id).map(item => item.id);
        let selectedWorkshopId = selectedWorkshop.filter(item => item?.id).map(item => item.id);

        if (selectedClient?.length <= 0) {
            errorAlert("Please select at least one client."); isValid = false;
        }

        if (!code_name) { setE_Data((pre) => ({ ...pre, code_name: "Code name is required" })); isValid = false; }
        if (!amount) { setE_Data((pre) => ({ ...pre, amount: "Percent is required" })); isValid = false; }
        if (!start_date) { setE_Data((pre) => ({ ...pre, start_date: "Start Date is required" })); isValid = false; }
        if (!end_date) { setE_Data((pre) => ({ ...pre, end_date: "End Date is required" })); isValid = false; }
        if (!single_use) { setE_Data((pre) => ({ ...pre, single_use: "Single Use is required" })); isValid = false; }
        if (!isValid) return;
        if (clientOPC?.length === selectedClient?.length) {
            isAllUsers = "Yes"
        }

        const formatCodeName = formatString(code_name);
        const formatAmountType = formatString(amountType);

        const payload = {
            "code_name": formatCodeName,
            "amount_type": formatAmountType,
            "amount": amount,
            "start_date": start_date,
            "end_date": end_date,
            "is_single_use": single_use,
            "isAllUsers": isAllUsers,
            "userListId": selectedClientId,
            "passListId": selectedPassId,
            "productListId": selectedProductId,
            "serviceListId": selectedServiceId,
            "workshopListId": selectedWorkshopId,
        }
        try {
            setLoader(true);
            const resp = await discountCodeDraftAPI(payload);
            if (resp) {
                setLoader(false);
                Swal.fire({
                    html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" alt='' />
                <h4 class="title text-capitalize text-center mt-4 textWhite">
                Success
              </h4>
              <p class="text-center my-4 textcolor">
              <small class="textWhite">
             ${resp.data.message} </small></p>
              `,
                    showClass: {
                        popup: 'custom-dialog-container',
                    },
                    customClass: {
                        confirmButton: 'custom-button custom-button-size modalbtn',
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        setLoader(false);
                        navigate("/discount-code-draft-list");
                    }
                });
            }

        } catch (error) {
            console.log("@Error--", error)

        } finally {
            setLoader(false);
        }

    }
    return (
        <>
            {loader && <div className="MainLoader"> <Spinner animation="border" /> </div>}
            <div className="MainDashboard">
                <div className="MainLayout">
                    <Row>
                        <Sidebar />
                        <Col>
                            <div className="RightSide">
                                <HeaderDashboard />
                                <section className="addClient innerContent">
                                    <div className="AddClientContent">

                                        <Container className="mb-5 pb-4">
                                            <div className="d-flex justify-content-between mb-3">
                                                <h4>Marketing & Discount Codes</h4>
                                                <div>
                                                    <button
                                                        onClick={() => { navigate('/discount-code-draft-list') }}
                                                        type="button"
                                                        className="btn btn-primary px-2 py-1 mx-3" style={{ fontSize: '1rem' }}>
                                                        Draft Code List
                                                    </button>
                                                    <button
                                                        onClick={() => { navigate('/discount-code-list') }}
                                                        type="button"
                                                        className="btn btn-primary px-2 py-1" style={{ fontSize: '1rem' }}>
                                                        Publish Code List
                                                    </button>
                                                </div>


                                            </div>
                                            <p className="open-sans">
                                                Marketing tools allow you to create and manage promotional discount
                                                codes for passes and workshops. This premium feature lets you offer
                                                special pricing that clients can apply at checkout—online, in the
                                                mobile app, or when processed by an admin. Once activated, you can
                                                create, enable, or disable discount codes, control their usage, and
                                                encourage new purchases through targeted promotions.
                                            </p>
                                            <Row className="mt-5">
                                                <hr />
                                                <Col className="col-12">
                                                    <Row className='mt-5'>
                                                        <Col className="col-md-4 mb-3">
                                                            <AddPassMultiSelect
                                                                labelText="Client List"
                                                                setSkillsdata={setSelectedClient}
                                                                options={clientOPC}
                                                                clear={clientClear}
                                                                setClear={setClientClear}
                                                                placeholder="Select clients"
                                                            />
                                                        </Col>
                                                        <Col className="col-md-4 mb-3">
                                                            <AddPassMultiSelect
                                                                labelText="Pass List"
                                                                setSkillsdata={setSelectedPass}
                                                                options={passOPC}
                                                                clear={passClear}
                                                                setClear={setPassClear}
                                                                placeholder="Select passes"
                                                            />
                                                        </Col>
                                                        <Col className="col-md-4 mb-3">
                                                            <AddPassMultiSelect
                                                                labelText="Product List"
                                                                setSkillsdata={setSelectedProduct}
                                                                options={productOPC}
                                                                clear={productClear}
                                                                setClear={setProductClear}
                                                                placeholder="Select product"
                                                            />
                                                        </Col>
                                                        <Col className="col-md-4 mb-3">
                                                            <AddPassMultiSelect
                                                                labelText="Workshop List"
                                                                setSkillsdata={setSelectedWorkshop}
                                                                options={workshopOPC}
                                                                clear={workshopClear}
                                                                setClear={setWorkshopClear}
                                                                placeholder="Select workshop"
                                                            />
                                                        </Col>
                                                        <Col className="col-md-4 mb-3">
                                                            <AddPassMultiSelect
                                                                labelText="Service List"
                                                                setSkillsdata={setSelectedService}
                                                                options={serviceOPC}
                                                                clear={serviceClear}
                                                                setClear={setServiceClear}
                                                                placeholder="Select service"
                                                            />
                                                        </Col>
                                                        <Col className="col-md-4 mb-3">
                                                            <SharedSelect
                                                                className='form-select custom-d-select'
                                                                lable="Single use per client ?"
                                                                onChange={changeHandler}
                                                                options={options}
                                                                name="single_use"
                                                                error={e_data?.single_use}
                                                            />
                                                        </Col>
                                                        <Col className="col-md-6 mb-3">
                                                            <InputField
                                                                type={"text"}
                                                                lable={"Discount code name"}
                                                                onChange={changeHandler}
                                                                name={"code_name"}
                                                                value={data?.code_name}
                                                                error={e_data?.code_name}
                                                            />
                                                        </Col>
                                                        <Col className="col-md-6 mb-3">
                                                            <div className="form-label inputLable mb-0 d-flex gap-2">

                                                                <label class="form-label inputLable">
                                                                    {/* <input type="checkbox"
                                                                            id="discountType"
                                                                            checked={amountType === 'percent' ? true : false}
                                                                            onChange={(e) => {
                                                                                e.target.checked ? setAmountType('percent') : setAmountType('percent')
                                                                            }} />
                                                                        <span class="slider discount-slider round" style={{ backgroundColor: "#02793f" }}>
                                                                            <span class="label-dollar"></span>
                                                                            <span class="label-percent">%</span>
                                                                        </span> */}
                                                                    Discount code Percent
                                                                </label>

                                                            </div>
                                                            <div>
                                                                {amountType === 'percent' ?
                                                                    <span className="form-label input-label input-d-icon">%</span>
                                                                    :
                                                                    <span className="form-label input-label input-d-icon">$</span>
                                                                }
                                                                <input
                                                                    style={{
                                                                        textAlign: 'right',
                                                                        paddingRight: '40px',
                                                                        background: '#f2f3f5'
                                                                    }}
                                                                    type='text'
                                                                    name='amount'
                                                                    value={data?.amount}
                                                                    className={"form-control"}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value === '') {
                                                                            changeHandler(e);
                                                                            return;
                                                                        }
                                                                        // allow numbers with optional decimal (max 2 digits)
                                                                        if (/^\d{0,2}(\.\d{0,1})?$/.test(value) && Number(value) <= 99.8) {
                                                                            changeHandler(e);
                                                                        }

                                                                        // allow only numbers and max 99
                                                                        // if (/^\d+$/.test(value) && Number(value) <= 99) {
                                                                        //     changeHandler(e);
                                                                        // }
                                                                    }}
                                                                />
                                                            </div>
                                                            <small className={"text-danger"}>{e_data?.amount}</small>
                                                        </Col>
                                                        <Col className="col-md-6 mb-3">

                                                            <div className="mb-3">
                                                                <label htmlFor='start_date' className="form-label inputLable">Promo Start date</label>
                                                                <input
                                                                    type='date'
                                                                    id='start_date'
                                                                    name='start_date'
                                                                    value={data?.start_date}
                                                                    min={new Date().toISOString().split("T")[0]}
                                                                    className="form-control"
                                                                    onChange={changeHandler}
                                                                />
                                                                <small className="text-danger">{e_data?.start_date}</small>
                                                            </div>
                                                        </Col>
                                                        <Col className="col-md-6 mb-3">
                                                            <div className="mb-3">
                                                                <label htmlFor='' className="form-label inputLable">Promo End Date</label>
                                                                <input
                                                                    type='date'
                                                                    id='end_date'
                                                                    name='end_date'
                                                                    value={data?.end_date}
                                                                    min={new Date().toISOString().split("T")[0]}
                                                                    className="form-control"
                                                                    onChange={(e) => {
                                                                        if (!data?.start_date) {
                                                                            errorAlert("Please select the start date first.");
                                                                            return;
                                                                        }

                                                                        if (e.target.value <= data?.start_date) {
                                                                            errorAlert("The end date should be greater than the start date.");
                                                                            return;
                                                                        }
                                                                        changeHandler(e);
                                                                    }}
                                                                />
                                                                <small className="text-danger">{e_data?.end_date}</small>
                                                            </div>
                                                        </Col>
                                                        <Col className="col-md-6 mt-4 d-flex justify-content-end">
                                                            <SharedButton
                                                                type="submit"
                                                                variant="primary"
                                                                title="Save In Draft"
                                                                className="btnform w-100"
                                                                onClick={saveHandler}
                                                            />
                                                        </Col>

                                                        <Col className="col-md-6 mt-4 d-flex justify-content-end">
                                                            <SharedButton
                                                                type="submit"
                                                                variant="primary"
                                                                title="Publish"
                                                                className="btnform w-100"
                                                                onClick={createHandler}
                                                            />


                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </section>
                                <Footer />
                            </div>
                        </Col>
                    </Row >
                </div >
            </div >
        </>
    );
};
